/*
* @providesModule EmailVerifyController
* 
*/

import {NativeModules} from 'react-native';
import CurrentUserStore from 'CurrentUserStore';
import NetClient from 'NetClient';

type Error = {responseObject: Array<{message: string, name: string}>};

const OnError = NativeModules.SKZAPIManager.OnError;

class EmailVerifyController {
  sendVerificationToken(email: string): Promise<number> {
    return new Promise((resolve: (response: number) => void, reject: (error: Error) => void) => {
      CurrentUserStore.getCurrentUserId().then((userId: string) => {
        if (userId) {
          const path = `users/${userId}/email/verification_tokens`;
          const body = {email};

          NetClient.postURL(path, body, OnError.promptRetry, (error: Error, response: number) => {
            if (response && !error) {
              resolve(response);
            } else {
              reject(error);
            }
          });
        }
      });
    });
  }
}

export default new EmailVerifyController();
